The details documenting a person's attendance at an educational institution.
